// @ts-nocheck
import * as React from "react";

const CubeFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m3 8.36 8.25 3.47V21h-.06L4 17.61a1.69 1.69 0 0 1-1-1.52V8.36Zm18 0v7.74a1.69 1.69 0 0 1-1 1.51L12.8 21h-.05v-9.17L21 8.36Zm-9.8-5.18a1.87 1.87 0 0 1 1.6 0L20 6.55c.193.092.367.22.51.38L12 10.5 3.49 6.93A1.62 1.62 0 0 1 4 6.55Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CubeFill);
